module.exports = __webpack_public_path__ + "static/logo-63f65645f54b0f1223f9d7699e535aa0.svg";